import { render, staticRenderFns } from "./write.vue?vue&type=template&id=6fa22def&scoped=true"
import script from "./write.vue?vue&type=script&lang=ts"
export * from "./write.vue?vue&type=script&lang=ts"
import style0 from "./write.vue?vue&type=style&index=0&id=6fa22def&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa22def",
  null
  
)

export default component.exports